import { DICT_USER_TYPE, getDictLabel } from '@/constant/dict';

export default function sampleDeviceColumns(Vue) {
  return [
    {
      title: "时间",
      key: "createTime",
      minWidth: 120,
      align: 'center'
    },
    {
      title: "姓名",
      key: "fullName",
      minWidth: 120,
      align: 'center'
    },
    {
      title: "手机号",
      key: "phone",
      align: 'center',
      minWidth: 120
    },
    {
      title: "用户类型",
      key: "userType",
      align: 'center',
      minWidth: 100,
      render: (h, { row }) => {
        const text = getDictLabel(DICT_USER_TYPE, row.userType + '')
        return h('span', {
        }, text)
      }
    }
  ]
}
